import { useState, useEffect, useRef } from "react";
import { Modal, Table, Button } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import React from "react";
import Captcha from "react-numeric-captcha";
import { apiStagingOutdoorUrl } from "../../../../../../constants";
import axios from "axios";

const initialValues = {
  drat: "",
  orderType: "",
  fromDate: "",
  toDate: "",
};

const validationSchema = Yup.object({
  drat: Yup.string().required("Required"),
  orderType: Yup.string().required("Required"),
  fromDate: Yup.string().required("Required"),
  toDate: Yup.string().required("Required"),
});

const PartyNameJudgeName = () => {
  const [captchaStatus, setCaptchaStatus] = useState(false);
  const capt = useRef();
  // state to control Model
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [fDate, setFDate] = useState("");
  const [tDate, setTDate] = useState("");

  useEffect(() => {
    fetchDratDrtLocation();
  }, []);

  const handleSubmit = (values, { resetForm }) => {
    const caseDetailData = {
      schemeNameDrtId: values.drat,
      dratDailyFinalOrderId: values.orderType,
      fromDate: fDate,
      toDate: tDate,
    };
    fetchCaseDetail("getDratOrderJudgementReportFromToDate", caseDetailData);
    setTimeout(() => {
      setIsOpenModal(true);
    }, 1000);
    setCaseDetail("");

    setCaptchaStatus(false);
    capt.current.refresh();
    // resetForm();
  };

  // fetching first dropDownData
  const [dratDrtLocations, setDratDrtLocations] = useState([]);
  const fetchDratDrtLocation = async () => {
    const res = await axios.post(
      `${apiStagingOutdoorUrl}/getDrtDratScheamName`
    );
    const sortedLocation = res.data.sort((a, b) =>
      a.SchemaName > b.SchemaName ? 1 : b.SchemaName > a.SchemaName ? -1 : 0
    );
    setDratDrtLocations(sortedLocation);
  };

  const [loading, setLoading] = useState(false);
  const [caseDetail, setCaseDetail] = useState([]);
  const [error, setError] = useState(false);
  const fetchCaseDetail = async (url, data) => {
    setLoading(true);
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const response = await axios.post(
        `${apiStagingOutdoorUrl}/${url}`,
        data,
        config
      );
      setCaseDetail(response.data);
    } catch (error) {
      setCaseDetail([]);
      setLoading(false);
      setError(true);
    }
    setLoading(false);
  };

  const doubleDigitDate = (date) => {
    // let date = "25/8/2022"
    if (date) {
      let arr = date.split("/");
      if (arr[0].length === 1) arr[0] = "0" + arr[0];
      if (arr[1].length === 1) arr[1] = "0" + arr[1];

      return arr.join("/");
    }
  };

  return (
    <div>
      <Formik
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        initialValues={initialValues}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          values,
          touched,
          errors,
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              {/* field 1 */}
              <div className="form-group row">
                <label
                  htmlFor="staticEmail"
                  className="col-sm-4 col-form-label mandatory"
                >
                  DRAT
                </label>
                <div className="col-sm-7">
                  <select
                    className="form-control"
                    placeholder=""
                    type="text"
                    id="drat"
                    name="drat"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.drat}
                  >
                    <option>Select DRAT</option>
                    {dratDrtLocations
                      .filter((item) => parseInt(item.schemeNameDrtId) > 99)
                      .map((item, index) => (
                        <option value={`${item.schemeNameDrtId}`} key={index}>
                          {item.SchemaName}
                        </option>
                      ))}
                  </select>
                  {touched.drat && errors.drat ? (
                    <div className="error">{errors.drat}</div>
                  ) : null}
                </div>
              </div>
              {/* field 2 */}
              <div className="form-group row">
                <label
                  htmlFor="staticEmail"
                  className="col-sm-4 col-form-label mandatory"
                >
                  Daily/Final Order
                </label>
                <div className="col-sm-7">
                  <select
                    className="form-control"
                    placeholder=""
                    type="text"
                    id="orderType"
                    name="orderType"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.orderType}
                  >
                    <option>Select Daily/Final Order</option>
                    <option value={1}>Daily Order</option>
                    <option value={2}>Final Order</option>
                  </select>
                  {touched.orderType && errors.orderType ? (
                    <div className="error">{errors.orderType}</div>
                  ) : null}
                </div>
              </div>
              {/* field 3 */}
              <div className="form-group row">
                <label
                  htmlFor="inputEmail4"
                  className="col-sm-4 col-form-label mandatory"
                >
                  From Date
                </label>
                <div className="col-sm-7">
                  <input
                    type="date"
                    id="fromDate"
                    name="fromDate"
                    className="form-control"
                    placeholder=""
                    onChange={(e) => {
                      handleChange(e);
                      setFDate(
                        e.currentTarget.value.split("-").reverse().join("/")
                      );
                    }}
                    onBlur={handleBlur}
                    value={values.fromDate}
                    autoComplete="off"
                  />
                  {touched.fromDate && errors.fromDate ? (
                    <div className="error">{errors.fromDate}</div>
                  ) : null}
                </div>
              </div>
              {/* field 4 */}
              <div className="form-group row">
                <label
                  htmlFor="inputEmail4"
                  className="col-sm-4 col-form-label mandatory"
                >
                  To Date
                </label>
                <div className="col-sm-7">
                  <input
                    type="date"
                    id="toDate"
                    name="toDate"
                    className="form-control"
                    placeholder=""
                    onChange={(e) => {
                      handleChange(e);
                      setTDate(
                        e.currentTarget.value.split("-").reverse().join("/")
                      );
                    }}
                    onBlur={handleBlur}
                    value={values.toDate}
                  />
                  {touched.toDate && errors.toDate ? (
                    <div className="error">{errors.toDate}</div>
                  ) : null}
                </div>
              </div>
              {/* field 5 */}
              <div className="form-group capcha-sec">
                <div className="col-sm-12 px-0 d-flex">
                  <Captcha
                    onChange={(status) => {
                      setCaptchaStatus(status);
                    }}
                    ref={capt}
                    required
                  />
                  <br />
                  <button
                    type="submit"
                    disabled={!captchaStatus}
                    className="btn btn-reload"
                  >
                    <i className="fas fa-search"><span className="sr-only">no text</span></i>
                  </button>
                </div>
                {!captchaStatus ? (
                  <div className="captcha-text">Enter valid captcha</div>
                ) : null}
              </div>
            </form>
            {loading ? (
              <h6 className="loader">Loading ......</h6>
            ) : (
              <Modal show={isOpenModal} onHide={() => setIsOpenModal(false)}>
                <Modal.Header className="d-flex justify-content-between align-items-start">
                  DRAT ORDER/JUDGEMENT REPORT
                  <Button
                    type="button"
                    className="close"
                    onClick={() => setIsOpenModal(false)}
                  >
                    &times;
                  </Button>
                </Modal.Header>
                <Modal.Body>
                  <div className="table-responsive">
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Sr.No.</th>
                          <th>
                            <center>Applicant V/S Respondent</center>
                          </th>
                          <th>Dairy No.</th>
                          <th>Application No.</th>
                          <th>Date of Order</th>
                          <th>Pronounced By</th>
                          <th>View Daily Order(s)</th>
                        </tr>
                      </thead>
                      {!error && caseDetail.length > 0 ? (
                        <tbody>
                          {caseDetail.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <center>
                                  {item.applicantName} <br />
                                  <strong>V/S</strong>
                                  <br />
                                  {item.respondentName}
                                </center>
                              </td>
                              <td>{item.diaryno}</td>
                              <td>{item.applicantno}</td>
                              <td>{doubleDigitDate(item.dateoffiling)}</td>
                              <td>{item.pronouncedBy}</td>
                              <td>
                                <a
                                  target="_blank"
                                  href={`${item.dailyOrderPdf}`}
                                >
                                  <i className="fas fa-search"><span className="sr-only">no text</span></i>
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td colSpan="9"> No Record Found </td>
                          </tr>
                        </tbody>
                      )}
                    </Table>
                  </div>
                </Modal.Body>
              </Modal>
            )}
          </>
        )}
      </Formik>
    </div>
  );
};

export default PartyNameJudgeName;
